import { Serializer } from 'jsonapi-serializer';
import { EmailValidationPayload } from '../interfaces/email-validation-payload.interface';
import { uuidv7 } from 'uuidv7';

const serializer = new Serializer('EmailValidation', {
	id: 'id',
	keyForAttribute: (attr: string) => attr,
	pluralizeType: false,
	attributes: ['email'],
	transform(record: any) {
		return {
			id: record.id ?? uuidv7(),
			...record,
		};
	},
});

export function serializeEmailValidation(emailValidation: EmailValidationPayload) {
	return serializer.serialize(emailValidation);
}
